import {
  Box,
  Button,
  Container,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
  Textarea,
  useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { HiArrowNarrowLeft } from "react-icons/hi";
// import { IAllCourse } from '../../../models/allcourse.model';
import { useNavigate, useParams } from "react-router";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
// import MyTrainerCourses from '../../../components/trainer/courses/MyCourses';

const TrNewDiscussionGroup = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const params = useParams();
  const course_id = params.course_id;

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.title) {
        errors.title = "Discussion Group Topic is required";
      }
      if (!values.description) {
        errors.description = "Discussion Group description is required";
      }
      return errors;
    },
    initialValues: {
      title: "",
      description: "",
    },
    onSubmit: async (values) => {
      const discussionGroupDetails: any = {
        title: values.title,
        description: values.description,
      };
      
      try {
        // POST REQUEST HERE
        if (course_id) {
          const discussionGroupResponse =
            await trainercoursesService.createDiscussionGroup(
              discussionGroupDetails,
              course_id
            );

          if (discussionGroupResponse) {
            toast({
              title: "Discussion Topic",
              description: "Discussion Topic Created",
              status: "success",
            });
          }
        }
      } catch (error) {
        toast({
          title: "Discussion Topic",
          description: "Something went Wrong. Try again later",
          status: "error",
        });
      }finally{
        navigate(-1);
      }
    },
  });

  return (
    <>
      <Box minHeight="100vh" bg="#F9F8F8" pb="40px" height="auto">
        <Container
          width={{ lg: "50%", md: "80%", sm: "95%", base: "95%" }}
          // maxWidth={"84%"}
          px={0}
          pt="100px"
          right={0}
          bg="F9F8F8"
          mx="auto"
        >
          <Box
            mb="60px"
            display="flex"
            alignItems="center"
            border="1px solid #616161"
            px="5px"
            py="7px"
            borderRadius="5px"
            cursor="pointer"
            width="200px"
          >
            <HiArrowNarrowLeft color="#616161" fontSize="20px" />
            <Text
              fontSize="14px"
              color="#616161"
              pl="5px"
              onClick={() =>
                navigate(`/trainer/course/${course_id}/discussions`)
              }
              fontWeight={700}
            >
              Back to Discussions
            </Text>
          </Box>
          <Box
            width={"100%"}
            bg="white"
            px="40px"
            py="30px"
            rounded="lg"
            boxShadow="sm"
            height={"auto"}
            mb="30px"
          >
            <Text fontWeight="700" fontSize="24px" color="#1E1E1E">
              New Discussion Topic
            </Text>
            <Box mt={4}>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mt={6}
                  mb="10px"
                  isInvalid={
                    formik.errors.title && formik.touched.title ? true : false
                  }
                >
                  <FormLabel
                    fontWeight="700"
                    color="brand.3"
                    mb="10px"
                    fontSize="14px"
                  >
                    Group Discussion Topic{" "}
                    <Text as="span" color="red">
                      (*){" "}
                    </Text>
                  </FormLabel>
                  <Input
                    type="text"
                    id="title"
                    name="title"
                    placeholder="Enter Group Discussion Topic"
                    onChange={formik.handleChange}
                    fontSize={13}
                    value={formik.values.title}
                    height={"2.5rem"}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.title}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  id="groupDescription"
                  mt={6}
                  mb="10px"
                  isInvalid={
                    formik.errors.description && formik.touched.description
                      ? true
                      : false
                  }
                >
                  <FormLabel
                    fontWeight="700"
                    color="brand.3"
                    mb="10px"
                    fontSize="14px"
                  >
                    Write here..
                  </FormLabel>
                  <Textarea
                    p={4}
                    bg="inputText.500"
                    fontSize={12}
                    size="sm"
                    minH="10rem"
                    placeholder="Enter Description here"
                    name="description"
                    onChange={formik.handleChange}
                    value={formik.values.description}
                  />
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.description}
                  </FormErrorMessage>
                </FormControl>

                <Flex mt={12} justifyContent="flex-end" width={"100%"}>
                  <Button
                    colorScheme="red"
                    type="submit"
                    isLoading={formik.isSubmitting}
                    size="sm"
                    px={6}
                    fontSize={14}
                  >
                    CREATE DISCUSSION TOPIC
                  </Button>
                </Flex>
              </form>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default TrNewDiscussionGroup;
